











import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import TagsInput from '../../crud/tags-input.component.vue';
import ToolConfigForm from './tool-config-form.component.vue';

export default {
  name: 'configurations-config-form',
  props: {
    toolConfig: {
      type: Object,
      required: true
    },
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    ToolConfigForm,
    TagsInput
  },
  data: function () {
    return {
      messages: this.$epb.messages.tools.instances.fields.tools[ActionTypeEnum.CONFIGURATION].fields
    };
  }
};
